<template>
  <div
    id="team_member"
    class="flex flex-row items-center"
    :class="noPadding ? '' : 'px-2 py-4'"
  >
    <div v-if="value.length" class="flex">
      <div class="flex -space-x-2">
        <a-avatar
          v-for="user in value.slice(0, maxAvatars)"
          :key="user.id"
          :style="{
            backgroundColor: getColor(user),
            width: `${avatarSize}px`,
            height: `${avatarSize}px`,
            lineHeight: `${avatarSize}px`,
            fontSize: `${avatarSize / 2.5}px`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }"
        >
          {{ getInitials(user.name) }}
        </a-avatar>
      </div>
      <div v-if="value.length > maxAvatars" class="flex items-center ml-1">
        <span class="text-sm font-normal">
          +{{ value.length - maxAvatars }}
        </span>
      </div>
    </div>
    <span v-else class="text-sm font-normal">No members</span>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import { colorSchema } from "@/src/constants/colorSchema.js";

const props = defineProps({
  value: {
    type: Array,
    default: () => [],
  },
  maxAvatars: {
    type: Number,
    default: 6,
  },
  avatarSize: {
    type: Number,
    default: 32,
  },
  noPadding: {
    type: Boolean,
    default: false,
  },
});

const store = useStore();
const storeUsers = computed(() => store.getters["users/users"] || []);
const avatarColors = Object.values(colorSchema);

const getInitials = (name) => {
  try {
    return name
      .split(" ")
      .map((word) => word[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  } catch (error) {
    console.error("An error occurred while getting initials: ", error);
    return "";
  }
};

const getColor = (user) => {
  try {
    if (user.avatar_color) return user.avatar_color;
    const found = storeUsers.value.find((u) => u.id === user.id);
    if (found?.avatar_color) return found.avatar_color;
    return avatarColors[parseInt(user.id) % avatarColors.length];
  } catch (error) {
    console.error("An error occurred while getting color: ", error);
    return avatarColors[0];
  }
};
</script>
